import React, { useEffect, useState } from "react";
import Icon from "../../assets/icons";
import Tabs from "../../components/tab";
import Refund from "./refund";
import Deduction from "./deduction";
import Restriction from "./restriction";

const BalanceAdjustment = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [activeTab, setActiveTab] = useState<
    "deduction" | "restriction" | "refund"
  >("deduction");
  const params = new URLSearchParams(new URL(window.location.href).search);
  const [currentPage, setCurrentPage] = useState(
    Number(params.get("page") || 1)
  );
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
  };

  const openNotification = () => {
    console.log("openNotification");
  };

  const updateUrlParams = (params: {
    [key: string]: string | number | null;
  }) => {
    const url = new URL(window.location.href);
    Object.keys(params).forEach((key) => {
      if (params[key] !== null) {
        url.searchParams.set(key, params[key]!.toString());
      } else {
        url.searchParams.delete(key);
      }
    });
    window.history.pushState({}, "", url.toString());
  };

  useEffect(() => {
    const storedSearchQuery = params.get("search") || "";
    const storedStatus = params.get("status") || "";
    const storedUserType = params.get("tab") || activeTab;
    const storedStartDate = params.get("startDate") || "";
    const storedEndDate = params.get("endDate") || "";

    setSearchQuery(storedSearchQuery);
    // setSelectedStatus(storedStatus);
    setActiveTab(storedUserType as "deduction" | "restriction" | "refund");
    // setStartDate(storedStartDate);
    // setEndDate(storedEndDate);
    // fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  useEffect(() => {
    updateUrlParams({
      page: currentPage,
      search: searchQuery,
      //   status: selectedStatus,
      tab: activeTab,
      //   startDate,
      //   endDate,
    });
    // fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, searchQuery, currentPage]);
  return (
    <>
      <div className="flex justify-between w-[95%]">
        <section>
          <h2 className="text-[24px] font-bold">
            Balance Adjustment
            <p className="text-[14px] font-normal">
              See the audit log of wallet deductions
            </p>
          </h2>
        </section>
        <section className="flex gap-4">
          <div className="border-2 rounded-md solid pl-5 bg-transparent h-[45px] flex gap-3">
            <Icon name="searchIcon" className="mt-3 rounded" />
            <input
              className="outline-none border-none w-[80%] bg-transparent"
              id="input-placeholder"
              placeholder="Search"
              value={searchQuery}
              onChange={handleSearchChange}
            />
          </div>
          <Icon name="downloadIcon" />

          <button className="-mt-3" onClick={openNotification}>
            <Icon name="notificationIcon" />
          </button>
        </section>
      </div>
      <div className="flex justify-between">
        <Tabs
          activeTab={activeTab}
          tabs={["deduction", "restriction", "refund"]}
          setActiveTab={setActiveTab}
        />
      </div>
      <div>
        {activeTab === "deduction" && <Deduction />}
        {activeTab === "restriction" && <Restriction />}
        {activeTab === "refund" && <Refund />}
      </div>
    </>
  );
};

export default BalanceAdjustment;
